export type KampanyaDurumu = "Aktif" | "Taslak" | "Durduruldu" | "Tamamlandı";
export type KampanyaTipi =
  | "Referans Kampanyası"
  | "Ödeme Hatırlatma"
  | "Taahhüt Bilgilendirme"
  | "Kampanya Duyurusu"
  | "Sistem Güncelleme"
  | "Yeni Kayıt Takibi";

export interface Kampanya {
  id: number;
  ad: string;
  tip: KampanyaTipi;
  durum: KampanyaDurumu;
  toplamKisi: number;
  gonderilen: number;
  bekleyen: number;
  hatali: number;
  baslamaTarihi: string;
  sonGonderim: string;
  aciklama: string;
  hedefKitle: string;
  mesajSablonu: string;
}

export const kampanyalarData: Kampanya[] = [
  {
    id: 1,
    ad: "Mayıs Referans Kampanyası",
    tip: "Referans Kampanyası",
    durum: "Aktif",
    toplamKisi: 243,
    gonderilen: 102,
    bekleyen: 141,
    hatali: 0,
    baslamaTarihi: "2026-05-01",
    sonGonderim: "2026-05-19 10:42",
    aciklama: "Mayıs ayı boyunca referans vermeyen tüm velilere gönderilecek referans isteme kampanyası.",
    hedefKitle: "Referans Vermeyen Veliler",
    mesajSablonu: "Merhaba %veli_adi, çocuğunuz %ogrenci_adi GoStudent ile büyük gelişim kaydetti. Bu başarıyı çevrenizle paylaşır mısınız?",
  },
  {
    id: 2,
    ad: "Mayıs Ödeme Hatırlatmaları",
    tip: "Ödeme Hatırlatma",
    durum: "Tamamlandı",
    toplamKisi: 87,
    gonderilen: 87,
    bekleyen: 0,
    hatali: 2,
    baslamaTarihi: "2026-05-01",
    sonGonderim: "2026-05-10 09:15",
    aciklama: "Mayıs ayı ödeme tarihinden 1 gün önce tüm aktif öğrencilerin velilerine gönderilen hatırlatma.",
    hedefKitle: "Aktif Öğrenciler",
    mesajSablonu: "Sayın %veli_adi, %ogrenci_adi için bu ayki ödemeniz %odeme_tarihi tarihinde. Hatırlatmak istedik.",
  },
  {
    id: 3,
    ad: "Haziran Kampanyası Duyurusu",
    tip: "Kampanya Duyurusu",
    durum: "Taslak",
    toplamKisi: 240,
    gonderilen: 0,
    bekleyen: 240,
    hatali: 0,
    baslamaTarihi: "2026-06-01",
    sonGonderim: "-",
    aciklama: "Haziran ayı için planlanan özel kampanya duyurusu. Henüz başlatılmadı.",
    hedefKitle: "Tüm Veliler",
    mesajSablonu: "Merhaba %veli_adi, Haziran kampanyamızla ilgili özel bir duyurumuz var...",
  },
  {
    id: 4,
    ad: "Taahhüt Bitiş Uyarıları",
    tip: "Taahhüt Bilgilendirme",
    durum: "Aktif",
    toplamKisi: 18,
    gonderilen: 6,
    bekleyen: 12,
    hatali: 0,
    baslamaTarihi: "2026-05-15",
    sonGonderim: "2026-05-18 14:30",
    aciklama: "Taahhüdü 30 gün içinde sona erecek öğrencilerin velilerine gönderilen yenileme bilgilendirmesi.",
    hedefKitle: "Taahhüdü Bitmek Üzere",
    mesajSablonu: "Sayın %veli_adi, %ogrenci_adi adlı öğrencinizin taahhüt süresi %taahhut_bitis_tarihi tarihinde sona ermektedir.",
  },
  {
    id: 5,
    ad: "Nisan Referans Kampanyası",
    tip: "Referans Kampanyası",
    durum: "Tamamlandı",
    toplamKisi: 198,
    gonderilen: 198,
    bekleyen: 0,
    hatali: 4,
    baslamaTarihi: "2026-04-01",
    sonGonderim: "2026-04-28 16:20",
    aciklama: "Nisan ayı referans kampanyası başarıyla tamamlandı.",
    hedefKitle: "Referans Vermeyen Veliler",
    mesajSablonu: "Merhaba %veli_adi, çocuğunuz %ogrenci_adi ile gurur duyuyoruz!",
  },
  {
    id: 6,
    ad: "Yeni Öğrenci Hoş Geldin",
    tip: "Yeni Kayıt Takibi",
    durum: "Durduruldu",
    toplamKisi: 14,
    gonderilen: 9,
    bekleyen: 5,
    hatali: 0,
    baslamaTarihi: "2026-05-10",
    sonGonderim: "2026-05-16 11:00",
    aciklama: "Yeni kayıt olan öğrencilere kayıt sonrası hoş geldin mesajları gönderilmektedir.",
    hedefKitle: "Yeni Kayıtlar",
    mesajSablonu: "Hoş geldiniz! %veli_adi hanım/bey, %ogrenci_adi öğrencimizi GoStudent ailesine kabul etmekten mutluluk duyuyoruz.",
  },
];

export const hatirlatmalarData = [
  {
    id: 1,
    ad: "Ödeme Tarihinden 1 Gün Önce Hatırlatma",
    tetikleyici: "Ödeme günü - 1 gün",
    sablon: "Ödeme Hatırlatma Şablonu",
    hedefKitle: "Aktif Öğrenciler",
    durum: "Aktif",
    sonCalisma: "2026-05-18 09:00",
    sonrakiCalisma: "2026-05-19 09:00",
    aciklama: "Her öğrencinin ödeme gününden 1 gün önce otomatik olarak velisine ödeme hatırlatma mesajı gönderir.",
    gonderilenSayisi: 87,
  },
  {
    id: 2,
    ad: "Ödeme Gecikmesi Takip Mesajı",
    tetikleyici: "Ödeme günü + 2 gün",
    sablon: "Gecikme Hatırlatma Şablonu",
    hedefKitle: "Ödeme Geciken Veliler",
    durum: "Aktif",
    sonCalisma: "2026-05-17 10:30",
    sonrakiCalisma: "2026-05-20 10:30",
    aciklama: "Ödeme yapılmayan velilere ödeme gününden 2 gün sonra takip mesajı gönderir.",
    gonderilenSayisi: 12,
  },
  {
    id: 3,
    ad: "Taahhüt Bitişinden 30 Gün Önce Bilgilendirme",
    tetikleyici: "Taahhüt bitiş tarihi - 30 gün",
    sablon: "Taahhüt Yenileme Şablonu",
    hedefKitle: "Taahhüdü Yaklaşan Öğrenciler",
    durum: "Aktif",
    sonCalisma: "2026-05-15 08:00",
    sonrakiCalisma: "2026-05-22 08:00",
    aciklama: "Taahhüt bitiş tarihi 30 günden az kalan öğrencilerin velilerine yenileme bilgilendirmesi gönderir.",
    gonderilenSayisi: 18,
  },
  {
    id: 4,
    ad: "Her Ay Başında Referans İsteme",
    tetikleyici: "Her ayın 1. günü",
    sablon: "Referans İsteme Şablonu",
    hedefKitle: "Referans Vermeyen Veliler",
    durum: "Aktif",
    sonCalisma: "2026-05-01 07:30",
    sonrakiCalisma: "2026-06-01 07:30",
    aciklama: "Her ayın ilk günü referans vermemiş tüm aktif velilere referans isteme mesajı gönderir.",
    gonderilenSayisi: 243,
  },
  {
    id: 5,
    ad: "Yeni Kayıt Sonrası 7. Gün Takip Mesajı",
    tetikleyici: "Kayıt tarihi + 7 gün",
    sablon: "Yeni Kayıt Takip Şablonu",
    hedefKitle: "Yeni Kayıtlar",
    durum: "Aktif",
    sonCalisma: "2026-05-16 11:00",
    sonrakiCalisma: "2026-05-23 11:00",
    aciklama: "Kayıt tarihinden 7 gün sonra yeni kayıt olan öğrencilerin velilerine ilerleme sorusu içeren mesaj gönderir.",
    gonderilenSayisi: 9,
  },
  {
    id: 6,
    ad: "Deneme Ders Sonrası Takip Mesajı",
    tetikleyici: "Deneme dersi + 1 gün",
    sablon: "Deneme Takip Şablonu",
    hedefKitle: "Deneme Dersi Alanlar",
    durum: "Pasif",
    sonCalisma: "2026-04-20 15:00",
    sonrakiCalisma: "-",
    aciklama: "Deneme dersinden 1 gün sonra veliye nasıl buldukları ve kaydolmak isteyip istemedikleri sorulur.",
    gonderilenSayisi: 34,
  },
];